import React, { useState } from "react";

import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance, { weburl } from "../../../axiosInstance";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import getCookie from "../../../helpers/getCookie";
import getDecryptData from "../../../helpers/getDecryptData";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LoadingScreen from "../../components/LoadingScreen";
import Select from "react-select";
import { DAYS,
  HOURS,
  MINUTES,
  PERIODS,
  defaultSlot,
  createEmptySchedule,
  parseTime,
  buildTime } from "../../../helpers/scheduleHelpers";
 import GooglePlaceSelect from "../../components/GooglePlaceSelect";

const UserViewEdit = () => {

  
     const { slug } = useParams();
  // STATS
const [stats, setStats] = useState([]);
const [newStat, setNewStat] = useState({ value: "", label: "" });
const [editingStatIndex, setEditingStatIndex] = useState(null);

const handleSaveStat = () => {
  if (!newStat.value || !newStat.label) return;

  if (editingStatIndex !== null) {
    // Update existing
    const updated = [...stats];
    updated[editingStatIndex] = newStat;
    setStats(updated);
    setEditingStatIndex(null);
  } else {
    // Add new
    setStats([...stats, newStat]);
  }

  setNewStat({ value: "", label: "" });
};

const handleEditStat = (index) => {
  setNewStat(stats[index]);
  setEditingStatIndex(index);
};

const handleDeleteStat = (index) => {
  setStats(stats.filter((_, i) => i !== index));
};

// CERTIFICATIONS
const [certifications, setCertifications] = useState([]);
const [newCert, setNewCert] = useState({ image: "", text: "" });
const [editingCertIndex, setEditingCertIndex] = useState(null);

const handleSaveCert = () => {
  if (!newCert.image || !newCert.text) return;

  if (editingCertIndex !== null) {
    const updated = [...certifications];
    updated[editingCertIndex] = newCert;
    setCertifications(updated);
    setEditingCertIndex(null);
  } else {
    setCertifications([...certifications, newCert]);
  }

  setNewCert({ image: "", text: "" });
};

const handleEditCert = (index) => {
  setNewCert(certifications[index]);
  setEditingCertIndex(index);
};

const handleDeleteCert = (index) => {
  setCertifications(certifications.filter((_, i) => i !== index));
};

// STORIES
const [stories, setStories] = useState([]);
const [newStory, setNewStory] = useState({
  link: "",
  title: "",
  description: "",
  date: "",
    image: "",
});
const [editingStoryIndex, setEditingStoryIndex] = useState(null);

const handleSaveStory = () => {
  if (!newStory.link || !newStory.title || !newStory.description || !newStory.date || !newStory.image)
    return;

  if (editingStoryIndex !== null) {
    const updated = [...stories];
    updated[editingStoryIndex] = newStory;
    setStories(updated);
    setEditingStoryIndex(null);
  } else {
    setStories([...stories, newStory]);
  }

  setNewStory({ link: "", title: "", description: "", date: "", image: "" });
};


const handleEditStory = (index) => {
  setNewStory(stories[index]);
  setEditingStoryIndex(index);
};

const handleDeleteStory = (index) => {
  setStories(stories.filter((_, i) => i !== index));
};

// eductation

const [educationList, setEducationList] = useState([]);

const [newEducation, setNewEducation] = useState("");

const [editingEducationIndex, setEditingEducationIndex] = useState(null);

const handleSaveEducation = () => {
  if (!newEducation.trim()) return;

  if (editingEducationIndex !== null) {
    const updated = [...educationList];
    updated[editingEducationIndex] = newEducation;
    setEducationList(updated);
    setEditingEducationIndex(null);
  } else {
    setEducationList([...educationList, newEducation]);
  }

  setNewEducation("");
};

const handleEditEducation = (index) => {
  setNewEducation(educationList[index]);
  setEditingEducationIndex(index);
};

const handleDeleteEducation = (index) => {
  setEducationList(educationList.filter((_, i) => i !== index));
};


// floor

const [floorList, setFloorList] = useState([]);
const [newFloor, setNewFloor] = useState("");
const [editingFloorIndex, setEditingFloorIndex] = useState(null);

const handleSaveFloor = () => {
  if (!newFloor.trim()) return;

  if (editingFloorIndex !== null) {
    const updated = [...floorList];
    updated[editingFloorIndex] = newFloor;
    setFloorList(updated);
    setEditingFloorIndex(null);
  } else {
    setFloorList([...floorList, newFloor]);
  }

  setNewFloor("");
};

const handleEditFloor = (index) => {
  setNewFloor(floorList[index]);
  setEditingFloorIndex(index);
};

const handleDeleteFloor = (index) => {
  setFloorList(floorList.filter((_, i) => i !== index));
};


const [filterInputs, setFilterInputs] = React.useState({
  location: "",
  placeId: "",
});

const handleLocationChange = (selected) => {
  console.log('selectedselectedselected',selected)
  setFilterInputs({
    location: selected?.label || "",
    placeId: selected?.value || "",
    lat: selected?.lat || "",
    lng: selected?.lng || "",

  });
};

  const navigate = useNavigate();
  const [filteredCities, setFilteredCities] = useState([]);

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
    const [Nurse, setAllNurse] = useState([]);
    const [Skill, setAllSkill] = useState([]);
    const [Attribute, setAllAttribute] = useState([]);

  const [dataNew, setDataNew] = useState([]);
  const [hidden, setHidden] = useState(true); // Add loading state
  const [hospitals, setHospitals] = useState([]);

  const [inputs, setInputs] = useState({
    type: "",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    gender: "1",
    DOB: "",
    address: "",
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const CreateSlug = (str) => {
    var slug = str;

    // Convert to lowercase
    slug = slug.toLowerCase();

    // Replace spaces with hyphens
    slug = slug.replace(/\s+/g, "-");

    // Remove special characters (only allow alphanumeric, hyphens, and underscores)
    slug = slug.replace(/[^a-z0-9\-]/g, "");

    return slug;
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;

    // Handle multi-checkbox logic
    if (type === "file") {
      // Handle file input
      newValue = files[0];
    } else {
      // Handle normal text inputs
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }

    // Capitalize the text for 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
      // Update the state with the new value
      setInputs((prevData) => ({
        ...prevData,
        profile_url: CreateSlug(newValue),
      }));
    }

    // Capitalize the text for 'username' field
    if (name === "profile_url") {
      newValue = CreateSlug(newValue);
    }


         if (name === "nurse") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.nurse) ? inputs.nurse : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          nurse: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
     if (name === "skill") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.skill) ? inputs.skill : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          skill: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
      if (name === "attribute") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.attribute) ? inputs.attribute : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          attribute: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }

  if (name === "Shift" || name === "DutyShift") {
    const selected = Array.isArray(inputs[name]) ? [...inputs[name]] : [];

    if (!selected.includes(value)) {
      selected.push(value);
      setInputs((prev) => ({
        ...prev,
        [name]: selected,
      }));
    }

      return null;
  }

      /* -------- NEW: HEADID (HOSPITAL MULTI-SELECT) -------- */
    if (name === "headId") {
      const selectedIds = Array.isArray(newValue) ? newValue : [];

      // maintain scheduleByHospital when hospitals change
      setHospitalSchedule((prev) => {
        const next = { ...prev };

        // add missing hospitals
        selectedIds.forEach((id) => {
          if (!next[id]) next[id] = createEmptySchedule();
        });

        // remove hospitals that are no longer selected
        Object.keys(next).forEach((id) => {
          if (!selectedIds.includes(id)) {
            delete next[id];
          }
        });

        return next;
      });
    }

    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleDescriptionChange = (value) => {
    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      about: value,
    }));
  };

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //form handle
  const fetchUserById = async () => {
     
    try {
      const { data } = await axiosInstance.get(`/admin/get-user/${slug}`);
      const { success, token, User,history ,message } = data;
      const existingUser = User;
      if (success) {

           const loadedSchedule = existingUser?.schedule || {};

        // ensure schedule has entries for every headId
        const headIds = existingUser?.headId || [];
        const normalizedSchedule = { ...loadedSchedule };
        headIds.forEach((hid) => {
          if (!normalizedSchedule[hid]) {
            normalizedSchedule[hid] = createEmptySchedule();
          }
        });

        setInputs((prevData) => ({
          ...prevData,
          username: existingUser.username || "",
          phone: existingUser.phone || "",
          email: existingUser.email || "",
          address: existingUser.address || "",
          pincode: existingUser.pincode || "",
          state: existingUser.state || "",
          statename: existingUser.statename || "",
          country: existingUser.country || "",
          city: existingUser.city || "",
          about: existingUser.about || "",
          department: existingUser.department || "",
          Doc1: existingUser.Doc1 || "",
          Doc2: existingUser.Doc2 || "",
          Doc3: existingUser.Doc3 || "",
          Doc4: existingUser.Doc4 || "",
          Doc5: existingUser.Doc5 || "",
          Doc6: existingUser.Doc6 || "",
          Doc7: existingUser.Doc7 || "",
          Doc8: existingUser.Doc8 || "",
          profile: existingUser.profile || "",
          gender: existingUser.gender || "",
          aadharno: existingUser.aadharno || "",
          pHealthHistory: existingUser.pHealthHistory || "",
          cHealthStatus: existingUser.cHealthStatus || "",
          empType: existingUser.empType || "",
          type: existingUser.type || "",
          AltAddress: existingUser.AltAddress || "",
            Experience: existingUser.Experience || "",
            estimate: existingUser.estimate || "",
          Shift: existingUser.Shift || "",
          DutyShift: existingUser.DutyShift || "",
          Education: existingUser.Education || "",
          MaritalStatus: existingUser.MaritalStatus || "",
          nurse: existingUser.nurse || "",
          skill: existingUser.skill || "",
          attribute: existingUser.attribute || "",
          Salary: existingUser.Salary || "",
          DOB: existingUser.DOB || "",
          history : history || [],
          headId : existingUser.headId || [],
          schedule : normalizedSchedule || {},
          subDepartments : existingUser?.subDepartments || {},
          location : existingUser?.location || '',
          room: existingUser?.room || '',
          // floorList: existingUser?.floorList || '',
        }));
    setHospitalSchedule(normalizedSchedule || {});
          console.log("success", normalizedSchedule);
setStats(existingUser?.stats || []);
setCertifications(existingUser?.certifications || []);
setStories(existingUser?.stories || []);
setEducationList(existingUser?.educationList || []);
setFloorList(existingUser?.floorList || []);
      }



    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchUserById();
  }, []);


  

  const handleSubmit = async () => {
   
    setSubmitLoading(false);
    console.log(inputs);
    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      // { name: "Gender", message: "Please enter Gender" },
      // { name: "DOB", message: "Please enter DOB" },
      // { name: "state", message: "Please enter State" },
      // { name: "pincode", message: "Please enter pincode" },
      // { name: "address", message: "Please enter address" },
      // { name: "profile", message: "Please choose profile photo" },
      // {
      //   name: "AadhaarFront",
      //   message: "Please choose Aadhaar Front photo ",
      // },
      // {
      //   name: "AadhaarBack",
      //   message: "Please choose Aadhaar Back photo ",
      // },
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(true);
        return;
      }
    }

    console.log("inputsinputs", inputs);

    const finaldata ={
      ...inputs,
      // schedule: hospitalSchedule,
       location: filterInputs?.location || "",
       lat: filterInputs?.lat || "",
       lng: filterInputs?.lng || "",
       stats,
       certifications,
       stories,
       educationList
    }
    console.log('finaldata',finaldata)
    try {
      const { data } = await axiosInstance.put(
        `/update-user-vendor/${slug}`,
        finaldata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { success } = data;
      if (success) {
        // navigate("/");

        toast.success("Account Updated Successfully  ");
      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones-department");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
      setData2(response.data.Department);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };



  // hospital logic start 
  const [hospitalSchedule, setHospitalSchedule] = useState({});

    const getScheduleByHospitalId = (hospitalId) =>
    hospitalSchedule[hospitalId] || createEmptySchedule();

const updateDay = (hospitalId, day, updater) => {
    setHospitalSchedule((prev) => {
      const all = { ...prev };
      const hs = all[hospitalId] || createEmptySchedule();
      all[hospitalId] = {
        ...hs,
        [day]: updater(hs[day]),
      };
      return all;
    });
  };

 

  const addSlot = (hospitalId, day) => {
    updateDay(hospitalId, day, (dayData) => ({
      ...dayData,
      slots: [...dayData.slots, { ...defaultSlot }],
    }));
  };

 const removeSlot = (hospitalId, day, idx) => {
    updateDay(hospitalId, day, (dayData) => ({
      ...dayData,
      slots: dayData.slots.filter((_, i) => i !== idx),
    }));
  };

 const toggleClosed = (hospitalId, day, closed) => {
    updateDay(hospitalId, day, (dayData) => ({
      ...dayData,
      isClosed: closed,
    }));
  };


  const updateSlotField = (hospitalId, day, idx, field, value) => {
    updateDay(hospitalId, day, (dayData) => {
      const newSlots = dayData.slots.map((slot, i) =>
        i === idx ? { ...slot, [field]: value } : slot
      );
      return { ...dayData, slots: newSlots };
    });
  };

    useEffect(() => {
    setInputs((prev) => ({
      ...prev,
      schedule: hospitalSchedule,
    }));
  }, [hospitalSchedule]);

  const fetchHospital = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/admin/all-user?empType=2&type=1");
       console.log("response.data.users,", response.data.users);
       setHospitals(response.data.users || []);
 
    } catch (error) {
      setHospitals([]);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    fetchData();
    fetchHospital();
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


    const removeNurse = (data) => {
    setInputs((prev) => ({
      ...prev,
      nurse: prev.nurse.filter((c) => c !== data),
    }));
  };

  
  const removeShift = (valueToRemove) => {
  setInputs(prev => ({
    ...prev,
    Shift: prev.Shift.filter(val => val !== valueToRemove)
  }));
};

  const removeDutyShift = (valueToRemove) => {
  setInputs(prev => ({
    ...prev,
    Shift: prev.Shift.filter(val => val !== valueToRemove)
  }));
};
 
    const removeSkill = (data) => {
    setInputs((prev) => ({
      ...prev,
      skill: prev.skill.filter((c) => c !== data),
    }));
  };


  
    const removeAttribute = (data) => {
    setInputs((prev) => ({
      ...prev,
      attribute: prev.attribute.filter((c) => c !== data),
    }));
  };
  

     const fetchNurseData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-nurse-department");
        console.log("response.data.Department,", response.data);
        setAllNurse(response.data.Department || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    
      const fetchNurseSkillData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-nurse-skill-department");
        console.log("response.data.Department,", response.data);
        setAllSkill(response.data.Department || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
     const fetchNurseAttributeData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-nurse-attributes-department");
        console.log("response.data.Attribute,", response.data);
        setAllAttribute(response.data.Department || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchNurseData();
      fetchNurseSkillData();
      fetchNurseAttributeData();
     }, []);
  
const selectedSubDepartments = inputs.department
  ? data2
      .filter((item) => inputs.department.includes(item._id) && item.value)
      .flatMap((item) =>
        item.value.map((sub) => ({
          parent: item.name,
          value: sub,
          label: `${item.name} → ${sub}`
        }))
      )
  : [];



  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />




        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="container pt-0">
              <div
                className="dashboard-content px-4 py-3 "
                style={{ maxWidth: "100vw" }}
              >
                <div className="col-md-6">
                  <label className="mb-4   h4">Update Profile </label>
                </div>
                {loading ? <LoadingScreen /> :
                  <div className="m-b20 row">
                    <div className="card  border-0 bg-white p-4 mb-4">
                      <div className="row">


                        <div className="mb-4">
                          <label className="form-label text-dark" htmlFor="name">
                            Full Name{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="text"
                              id="username"
                              className="form-control"
                              name="username"
                              value={inputs.username}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="email">
                            Email{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              readOnly
                              type="email"
                              id="email"
                              className="form-control"
                              name="email"
                              value={inputs.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="phone">
                            Phone{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              readOnly
                              type="email"
                              id="phone"
                              className="form-control"
                              name="phone"
                              value={inputs.phone}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label
                            className="form-label text-dark"
                            htmlFor="gender"
                          >
                            Gender{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              value={inputs.gender}
                              name="gender"
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                Select Gender
                              </option>
                              <option value="1">Male</option>
                              <option value="2">Female</option>
                              <option value="0">Other</option>
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            State{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            {/* <select
                              className="form-control"
                              id="state"
                              name="state"
                              value={inputs.state}
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                {loading ? "Loading..." : "Select State"}
                              </option>
                              {data.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}{" "}
                              ;
                            </select> */}

                                 <Select
                                                          options={
                                                            data
                                                              ? data.map((item) => ({
                                                                  value: item._id,
                                                                  label: item.name,
                                                                }))
                                                              : []
                                                          }
                                                          placeholder={loading ? "Loading..." : "Select State"}
                                                          isSearchable={true}
                                                          className="w-100"
                                                          value={
                                                            data
                                                              ? data
                                                                  .map((item) => ({
                                                                    value: item._id,
                                                                    label: item.name,
                                                                  }))
                                                                  .find((option) => option.value === inputs.state) || null
                                                              : null
                                                          }
                                                          onChange={(selectedOption) => {
                                                            handleChange({
                                                              target: {
                                                                name: "state",
                                                                value: selectedOption ? selectedOption.value : "",
                                                              },
                                                            });
                                                          }}
                                                        />

                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="city">
                            City{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            {/* <select
                              className="form-control"
                              id="city"
                              name="city"
                              value={inputs.city}
                              onChange={handleChange}
                            >
                              <option selected value={""} disabled>
                                {" "}
                                {!inputs.city ? "Select City" : inputs.city}
                              </option>
                              {filteredCities.map((city, index) => (
                                <option key={index} value={city}>
                                  {city}
                                </option>
                              ))}{" "}
                              ;
                            </select> */}


                               <Select
                              options={
                                filteredCities?.length
                                  ? filteredCities.map((city) => ({
                                      value: city,
                                      label: city,
                                    }))
                                  : []
                              }
                              placeholder={!inputs.city ? "Select City" : inputs.city}
                              isSearchable
                              className="w-100"
                              value={
                                inputs.city
                                  ? { value: inputs.city, label: inputs.city }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                handleChange({
                                  target: {
                                    name: "city",
                                    value: selectedOption?.value || "",
                                  },
                                });
                              }}
                            />


                          </div>
                        </div>

                        <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="aadharno">
                            Pincode
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <input
                              type="number"

                              id="pincode"
                              className="form-control custom-date"
                              name="pincode"
                              value={inputs.pincode}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="aadharno">
                            DOB
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <input
                              type="date" 
                              id="DOB"
                              className="form-control custom-date"
                              name="DOB"
                              value={inputs.DOB ? inputs.DOB.split('T')[0] : ''} // <-- fixes the value format
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="password"
                              value={inputs.password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Confirm Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="confirm_password"
                              value={inputs.confirm_password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>
 
 


 
         <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="department">
                            Department{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            {/* <select
                              className="form-control"
                              id="department"
                              name="department"
                              value={inputs.department}
                              onChange={handleChange}
                            >
                              <option selected >
                                {" "}
                                Select department
                              </option>
                              {data2.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}{" "}
                              ;
                            </select> */}
                                {/* <Select
                              isMulti
                              options={data2.map((item) => ({
                                value: item._id,
                                label: item.name,
                              }))}
                            
                              placeholder="Select department"
                              className="w-100"
                              value={
                                inputs.department && Array.isArray(inputs.department)
                                  ? inputs.department.map((id) => {
                                      const dep = data2.find((item) => item._id === id);
                                      return dep ? { value: dep._id, label: dep.name } : null;
                                    }).filter(Boolean)
                                  : []
                              }
                              onChange={(selectedOptions) => {
                                handleChange({
                                  target: {
                                    name: "department",
                                    value: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
                                  },
                                });
                              }}
                            /> */}
                            
                            <Select
  isMulti
  options={data2.map((item) => ({
    value: item._id,
    label: item.name,
  }))} 
  placeholder="Select department"
  className="w-100"
  value={
    inputs.department && Array.isArray(inputs.department)
      ? inputs.department.map((id) => {
          const dep = data2.find((item) => item._id === id);
          return dep ? { value: dep._id, label: dep.name } : null;
        }).filter(Boolean)
      : []
  }
  onChange={(selectedOptions) => {
    const selectedIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];

    // Update department selection
    handleChange({
      target: {
        name: "department",
        value: selectedIds,
      },
    });

    // Reset sub departments when department changes
    handleChange({
      target: {
        name: "subDepartments",
        value: [],
      },
    });
  }}
/>

                            
                          </div>
                        </div>
 
   

{selectedSubDepartments.length > 0 && (
  
        <div className="mb-4 col-12 "> 
         <label className="form-label text-dark" htmlFor="subDepartments">
                           Sub Departments{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
  <Select
    isMulti
    placeholder="Select Sub-Departments"
    className="w-100 mt-3"
    options={selectedSubDepartments}
    value={
      inputs.subDepartments?.map((sub) => {
        const found = selectedSubDepartments.find((item) => item.value === sub);
        return found ? { value: found.value, label: found.label } : null;
      }).filter(Boolean) || []
    }
    onChange={(selectedOptions) => {
      handleChange({
        target: {
          name: "subDepartments",
          value: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
        },
      });
    }}
  />
           </div>
)}

     

{inputs.type === 1 && inputs.empType === 3 && <>

    <div className="mb-4 col-12 ">
                                        <label className="form-label text-dark" htmlFor="headId">
                                          Hospitals{" "} 
                                          <span className="text-danger"> ( Required )</span>
                                        </label>
                                        <div className="input-group    input-sm">
                                        
              
                                          <Select
                isMulti
                options={hospitals.map((item) => ({
                  value: item._id,
                  label: item.username,
                }))}
              
                placeholder="Select Hospitals"
                className="w-100"
                value={
                  inputs.headId && Array.isArray(inputs.headId)
                    ? inputs.headId.map((id) => {
                        const dep = hospitals.find((item) => item._id === id);
                        return dep ? { value: dep._id, label: dep.username } : null;
                      }).filter(Boolean)
                    : []
                }
                onChange={(selectedOptions) => {
                  handleChange({
                    target: {
                      name: "headId",
                      value: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
                    },
                  });
                }}
              />
              
              
              
                                        </div>
                                      </div>


 <div className="col-md-12">
   {/* TIMINGS UI FOR EACH SELECTED HOSPITAL */}
        {Array.isArray(inputs.headId) &&
          inputs.headId.map((hId) => {
          const hospital = hospitals.find((h) => h._id === hId);
            const schedule = getScheduleByHospitalId(hId);

            return (
              <div key={hId} className="mb-4 border rounded p-3">
                <h6 className="fw-bold mb-3">
                  Timings for: {hospital?.username || "Hospital"}
                </h6>

                <table className="table table-sm mb-0">
                  <tbody>
                    {DAYS.map((day) => {
                      const dayData = schedule[day];

                      return (
                        <tr key={day}>
                          <td
                            
                          >
                            {day}
                          </td>

                          {/* Closed checkbox */}
                          <td  >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`${hId}-${day}-closed`}
                                checked={(dayData.isClosed === true ||dayData.isClosed === "true")}
                                onChange={(e) =>
                                  toggleClosed(hId, day, e.target.checked)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`${hId}-${day}-closed`}
                              >
                                Closed
                              </label>
                            </div>
                          </td>

                          {/* Time slots */}
                          <td colSpan={4}>
                            {(dayData.isClosed === true ||dayData.isClosed === "true")  ? (
                              <span className="text-muted">
                                Closed for this day
                              </span>
                            ) : (
                              dayData.slots.map((slot, idx) => {
                                const openParts = parseTime(slot.open);
                                const closeParts = parseTime(slot.close);

                                return (
                                  <div
                                    key={idx}
                                    className="d-flex flex-wrap align-items-center mb-2"
                                  >
                                    {/* Opens at */}
                                    <span className="me-1 small">Opens</span>
                                    <select
                                      className="form-select form-select-sm w-auto me-1 pe-4"
                                      value={openParts.hour}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "open",
                                          buildTime(
                                            e.target.value,
                                            openParts.minute,
                                            openParts.period
                                          )
                                        )
                                      }
                                    >
                                      {HOURS.map((h) => (
                                        <option key={h} value={h}>
                                          {h}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      className="form-select form-select-sm w-auto me-1 pe-4"
                                      value={openParts.minute}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "open",
                                          buildTime(
                                            openParts.hour,
                                            e.target.value,
                                            openParts.period
                                          )
                                        )
                                      }
                                    >
                                      {MINUTES.map((m) => (
                                        <option key={m} value={m}>
                                          {m}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      className="form-select form-select-sm w-auto me-3 pe-4"
                                      value={openParts.period}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "open",
                                          buildTime(
                                            openParts.hour,
                                            openParts.minute,
                                            e.target.value
                                          )
                                        )
                                      }
                                    >
                                      {PERIODS.map((p) => (
                                        <option key={p} value={p}>
                                          {p}
                                        </option>
                                      ))}
                                    </select>

                                    {/* Closes at */}
                                    <span className="me-1 small">Closes</span>
                                    <select
                                      className="form-select form-select-sm w-auto me-1 pe-4"
                                      value={closeParts.hour}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "close",
                                          buildTime(
                                            e.target.value,
                                            closeParts.minute,
                                            closeParts.period
                                          )
                                        )
                                      }
                                    >
                                      {HOURS.map((h) => (
                                        <option key={h} value={h}>
                                          {h}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      className="form-select form-select-sm w-auto me-1 pe-4"
                                      value={closeParts.minute}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "close",
                                          buildTime(
                                            closeParts.hour,
                                            e.target.value,
                                            closeParts.period
                                          )
                                        )
                                      }
                                    >
                                      {MINUTES.map((m) => (
                                        <option key={m} value={m}>
                                          {m}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      className="form-select form-select-sm w-auto me-3 pe-4"
                                      value={closeParts.period}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "close",
                                          buildTime(
                                            closeParts.hour,
                                            closeParts.minute,
                                            e.target.value
                                          )
                                        )
                                      }
                                    >
                                      {PERIODS.map((p) => (
                                        <option key={p} value={p}>
                                          {p}
                                        </option>
                                      ))}
                                    </select>

                                    {/* Number of patients */}
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control form-control-sm pe-0 me-2"
                                      placeholder="No. of patients"
                                      value={slot.patients}
                                      onChange={(e) =>
                                        updateSlotField(
                                          hId,
                                          day,
                                          idx,
                                          "patients",
                                          e.target.value
                                        )
                                      }
                                      style={{width:120}}
                                    />

                                    {/* + / delete slot */}
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary btn-sm me-2"
                                      onClick={() => addSlot(hId, day)}
                                    >
                                      +
                                    </button>
                                    {dayData.slots.length > 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() =>
                                          removeSlot(hId, day, idx)
                                        }
                                      >
                                         <i class="ri-delete-bin-6-fill"></i>
                                      </button>
                                    )}
                                  </div>
                                );
                              })
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>


              </div>
            );
          })}

 </div>

</>}

                 
    

        <div className="mb-4 col-12  ">
                          <label className="form-label text-dark" htmlFor="email">
                 {inputs.location ? 'Change Location': 'Choose Location ' }
                  <span className="text-danger"> ( Required )</span>
               
                           </label>
                           {inputs.location &&  <p className="small"> <span className="text-success"> Current :</span> {inputs.location} </p> }
                          <div className="input-group    input-sm">
                           
<GooglePlaceSelect
  value={
    filterInputs.placeId
      ? { label: filterInputs.location, value: filterInputs.placeId , lat : filterInputs.lat,
              lng : filterInputs.lng }
      : null
  }
  onChange={handleLocationChange}
/>
                          </div>
                        </div>




                        <div className="mb-4 col-12  ">
                          <label className="form-label text-dark" htmlFor="email">
                 
                  Full Address <span className="text-danger"> ( Required )</span>
               
                           </label>
                          <div className="input-group    input-sm">
                            <textarea
                              id="pincode"
                              className="form-control custom-date"
                              name="address"
                              value={inputs.address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

             
{inputs.type === 1 && inputs.empType === 3 && <> 
          
                 <div className="mb-4 col-md-3">
                  <label className="form-label text-dark" htmlFor="Salary">
                   Appointment Fees  <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="number"
                      className="form-control"
                      id="Salary"
                      name="Salary"
                      onChange={handleChange}
                      value={inputs.Salary}
                    /> 
                  </div>
                </div>

                 <div className="mb-4 col-md-3 ">
                  <label className="form-label text-dark" htmlFor="Salary">
                   Experience <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="number"
                      className="form-control"
                      id="Experience"
                      name="Experience"
                      onChange={handleChange}
                      value={inputs.Experience}
                    /> 
                  </div>
                </div>

                    <div className="mb-4 col-md-3 ">
                  <label className="form-label text-dark" htmlFor="estimate">
                   EST Time (min) <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="number"
                      className="form-control"
                      id="estimate"
                      name="estimate"
                      onChange={handleChange}
                      value={inputs.estimate}
                    /> 
                  </div>
                </div>


       <div className="mb-4 col-md-3 ">
                  <label className="form-label text-dark" htmlFor="room">
                   Room <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="text"
                      className="form-control"
                      id="room"
                      name="room"
                      onChange={handleChange}
                      value={inputs.room}
                    /> 
                  </div>
                </div>

</>}
 

{inputs.type === 1 && inputs.empType === 2 && <>
 <div className="card mb-3">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Floor</h5>
    <span className="badge bg-secondary">Items: {floorList.length}</span>
  </div>

  <div className="card-body">
    {/* Education List */}
    {floorList.length > 0 ? (
      <ul className="list-group mb-3">
        {floorList.map((edu, index) => (
          <li
            key={index}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <span>{edu}</span>

            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => handleEditFloor(index)}
                type="button"
              >
                Edit
              </button>

              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => handleDeleteFloor(index)}
                type="button"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted fst-italic">No Floor added yet.</p>
    )}

    {/* Add / Edit Education */}
    <div className="border rounded p-3 bg-light">
      <h6 className="mb-3">
        {editingFloorIndex !== null ? "Edit Floor" : "Add Floor"}
      </h6>

      <input
        type="text"
        className="form-control mb-2"
        placeholder="Enter Floor"
        value={newFloor}
        onChange={(e) => setNewFloor(e.target.value)}
      />

      <div className="d-flex gap-2">
        <button
          className="btn btn-secondary"
          onClick={handleSaveFloor}
          type="button"
        >
          {editingFloorIndex !== null ? "Update" : "Add"}
        </button>

        {editingFloorIndex !== null && (
          <button
          type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              setNewFloor("");
              setEditingFloorIndex(null);
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  </div>
</div>

</>}
     

 
     {(inputs.empType === 4 && inputs.type === 1 && !hidden) && <>
                                         <div className="mb-4 ">
                  <label className="form-label text-dark" htmlFor="AltAddress">
                   Current Address  
                  </label>
                  <div className="input-group    input-sm">
                    <textarea
                      className="form-control"
                      id="AltAddress"
                      name="AltAddress"
                      onChange={handleChange}
                      rows="2"
                    >
                      {inputs.AltAddress}
                    </textarea>
                  </div>
                </div>

<div className="mb-4 col-md-3">
  <label className="form-label text-dark" htmlFor="Shift">
    Shift  
    <span className="text-danger"> (Required)</span>
  </label>

  <div className="input-group input-sm">
    <select
      className="form-control"
      id="Shift"
      name="Shift"
      onChange={handleChange}
      value=""
      required
    >
      <option value="">Select Shift</option>
      <option value="Day">Day</option>
      <option value="Night">Night</option>
    </select>
  </div>

  <div className="mb-4">
    {Array.isArray(inputs.Shift) && inputs.Shift.length > 0 ? (
      inputs.Shift.map((shiftValue, index) => (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeShift(shiftValue)}
          title="Click to remove"
        >
          {shiftValue} ×
        </span>
      ))
    ) : (
      <span className="text-muted">No shift selected.</span>
    )}
  </div>
</div>

<div className="mb-4 col-md-3">
  <label className="form-label text-dark" htmlFor="DutyShift">
    Duty Shift  
    <span className="text-danger"> ( Required )</span>
  </label>
  
  <div className="input-group input-sm">
    <select
      className="form-control"
      id="DutyShift"
      name="DutyShift"
      onChange={handleChange}
      value=""
      required
    >
      <option value="">Select Duty Shift</option>
      <option value="8 Hours">8 Hours</option>
      <option value="10 Hours">10 Hours</option>
      <option value="12 Hours">12 Hours</option>
      <option value="24 Hours">24 Hours</option>
    </select>
  </div>

  <div className="mb-4">
    {Array.isArray(inputs.DutyShift) && inputs.DutyShift.length > 0 ? (
      inputs.DutyShift.map((shiftValue, index) => (
        <span
          key={index}
          className="badge bg-success me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeDutyShift(shiftValue)}
          title="Click to remove"
        >
          {shiftValue} ×
        </span>
      ))
    ) : (
      <span className="text-muted">No duty shift selected.</span>
    )}
  </div>
</div>


          <div className="mb-4 col-md-6 ">
                  <label className="form-label text-dark" htmlFor="Education">
                   Education <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="text"
                      className="form-control"
                      id="Education"
                      name="Education"
                      onChange={handleChange}
                      value={inputs.Education}
                    /> 
                  </div>
                </div>


  <div className="mb-4 col-md-6 ">
                    <label className="form-label text-dark" htmlFor="MaritalStatus">
                      Marital status <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={inputs.MaritalStatus}
                        name="MaritalStatus"
                        onChange={handleChange}
                      >
                        <option selected disabled>
                          {" "}
                          Select status
                        </option>
                        <option value="Married">Married</option>
                        <option value="Unmarried">Unmarried</option>
                       </select>
                    </div>
                  </div>


    
      {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse Department <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="nurse"
            name="nurse"
         onChange={handleChange}
         selected={inputs.nurse}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Nurse Department
            </option>
            {Nurse.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.nurse) && inputs.nurse.length > 0 ? (
   inputs.nurse.map((departmentId, index) => {
      const department = Nurse.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeNurse(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Nurse department selected.</span>
  )}
</div>


 {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse skill <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="skill"
            name="skill"
         onChange={handleChange}
         selected={inputs.skill}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Skill Department
            </option>
            {Skill.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.skill) && inputs.skill.length > 0 ? (
     inputs.skill.map((departmentId, index) => {
      const department = Skill.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeSkill(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Skill department selected.</span>
  )}
</div>




 {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse Attribute <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="attribute"
            name="attribute"
         onChange={handleChange}
         selected={inputs.attribute}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Attribute Department
            </option>
            {Attribute.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.attribute) && inputs.attribute.length > 0 ? (
    inputs.attribute.map((departmentId, index) => {
      const department = Attribute.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeAttribute(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Attribute department selected.</span>
  )}
</div>



                                         </>}


<hr/>
   <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="profileImage">
                            Profile Image
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
  {inputs.profile && typeof inputs.profile === "string" ? (
    <img
      src={inputs.profile !== "" ? weburl + inputs.profile : "/img/profile-default.png"}
      id="ProfileImage"
      alt="Profile Image"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: "",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />
  ) : (
    <img
      src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" 
        ? weburl + inputs.profile 
        : "/img/profile-default.png"}
      id="ProfileImage"
      alt="Profile Image"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: "",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />
  )}
  <input
    type="file"
    id="profileImage"
    className="form-control"
    name="profileImage"
    accept=".jpg, .jpeg, .png, .webp"
    onChange={(event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imgElement = document.getElementById("ProfileImage");
          if (imgElement) {
            imgElement.src = e.target.result; // Set the image URL directly on the img element
          }
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
      }
    }}
  />
</div>

                        </div>
 

                        {/* <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc1">
                            Document 1
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
  {inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1.indexOf(".pdf") !== -1 ? (
    <embed
      src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
      id="LicensingImage"
      alt="Document 1"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: 5,
        objectFit: "contain",
        border: "1px solid grey",
      }}
    />
  ) : (
    <img
      src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
      id="LicensingImage"
      alt="Document 1"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: 5,
        objectFit: "contain",
        border: "1px solid grey",
      }}
    />
  )}
  <input
    type="file"
    id="Doc1"
    className="form-control"
    name="Doc1"
    accept=".jpg, .jpeg, .png, .pdf, .webp"
    onChange={(event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imgElement = document.getElementById("LicensingImage");
          if (imgElement) {
            var computedStyle = window.getComputedStyle(imgElement);
            var allStyles = "";
            for (var i = 0; i < computedStyle.length; i++) {
              var styleProperty = computedStyle[i];
              allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
            }

            var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
            iframe.src = e.target.result;
            iframe.style.cssText = allStyles;
            iframe.style.border = "none";
            iframe.id = imgElement.id;
            imgElement.parentNode.replaceChild(iframe, imgElement);
          }
        };
        reader.readAsDataURL(file);
        setInputs((prevData) => ({ ...prevData, Doc1: file }));
      }
    }}
  />
</div>


                        </div> */}

                        {/* Duplicate for Doc2 */}
                        <div className="mb-4 col-6 col-md-4">
                          <label className="form-label text-dark" htmlFor="Doc2">
                            Aadhaar card (Front)
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
                            {inputs.Doc2 && typeof inputs.Doc2 === "string" && inputs.Doc2.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                id="LicensingImage2"
                                alt="Document 2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                id="LicensingImage2"
                                alt="Document 2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc2"
                              className="form-control"
                              name="Doc2"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage2");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc2: file }));
                                }
                              }}
                            />
                          </div>
                        </div>

                        {/* Duplicate for Doc3 */}
                        <div className="mb-4 col-6 col-md-4">
                          <label className="form-label text-dark" htmlFor="Doc3">
                            Aadhaar card (Back)
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
                            {inputs.Doc3 && typeof inputs.Doc3 === "string" && inputs.Doc3.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                id="LicensingImage3"
                                alt="Document 3"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                id="LicensingImage3"
                                alt="Document 3"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc3"
                              className="form-control"
                              name="Doc3"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage3");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc3: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        

  {/* Duplicate for Doc4 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc4">
                            Document 4
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc4 && typeof inputs.Doc4 === "string" && inputs.Doc4.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc4 !== "" ? weburl + inputs.Doc4 : "/img/imageupload.png"}
                                id="LicensingImage4"
                                alt="Document 4"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc4 !== "" ? weburl + inputs.Doc4 : "/img/imageupload.png"}
                                id="LicensingImage4"
                                alt="Document 4"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc4"
                              className="form-control"
                              name="Doc4"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage4");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc4: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        
                          {/* Duplicate for Doc5 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc5">
                            Document 5
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc5 && typeof inputs.Doc5 === "string" && inputs.Doc5.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc5 !== "" ? weburl + inputs.Doc5 : "/img/imageupload.png"}
                                id="LicensingImage5"
                                alt="Document 5"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc5 !== "" ? weburl + inputs.Doc5 : "/img/imageupload.png"}
                                id="LicensingImage5"
                                alt="Document 5"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc5"
                              className="form-control"
                              name="Doc5"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage5");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc5: file }));
                                }
                              }}
                            />
                          </div>
                        </div>

                                             {/* Duplicate for Doc6 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc6">
                            Document 6
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc6 && typeof inputs.Doc6 === "string" && inputs.Doc6.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc6 !== "" ? weburl + inputs.Doc6 : "/img/imageupload.png"}
                                id="LicensingImage6"
                                alt="Document 6"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc6 !== "" ? weburl + inputs.Doc6 : "/img/imageupload.png"}
                                id="LicensingImage6"
                                alt="Document 6"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc6"
                              className="form-control"
                              name="Doc6"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage6");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc6: file }));
                                }
                              }}
                            />
                          </div>
                        </div>


                     {/* Duplicate for Doc7 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc7">
                            Document 7
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc7 && typeof inputs.Doc7 === "string" && inputs.Doc7.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc7 !== "" ? weburl + inputs.Doc7 : "/img/imageupload.png"}
                                id="LicensingImage7"
                                alt="Document 7"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc7 !== "" ? weburl + inputs.Doc7 : "/img/imageupload.png"}
                                id="LicensingImage7"
                                alt="Document 7"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc7"
                              className="form-control"
                              name="Doc7"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage7");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc7: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        
                                             {/* Duplicate for Doc8 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc8">
                            Document 8
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc8 && typeof inputs.Doc8 === "string" && inputs.Doc8.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc8 !== "" ? weburl + inputs.Doc8 : "/img/imageupload.png"}
                                id="LicensingImage8"
                                alt="Document 8"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc8 !== "" ? weburl + inputs.Doc8 : "/img/imageupload.png"}
                                id="LicensingImage8"
                                alt="Document 8"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc8"
                              className="form-control"
                              name="Doc8"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage8");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc8: file }));
                                }
                              }}
                            />
                          </div>
                        </div>


                        <div className="mb-4 col-12">
                          <label className="form-label text-dark" htmlFor="email">
                            About
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <ReactQuill
                            value={inputs.about}
                            onChange={handleDescriptionChange}
                            modules={{
                              toolbar: [
                                [
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                              ],
                            }}
                            formats={[
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                            ]}
                            bounds={".app"}
                          />
                        </div>

 

{inputs.type === 1 && inputs.empType === 2 && <> 
 <div className="card mb-3">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">About Stats</h5>
    <span className="badge bg-primary">Stats: {stats.length}</span>
  </div>

  <div className="card-body">
    {/* Stats Display */}
    {stats.length > 0 ? (
      <div className="d-flex flex-wrap gap-3 mb-3">
        {stats.map((item, index) => (
          <div
            key={index}
            className="border rounded p-3 bg-light d-flex flex-column justify-content-between"
            style={{ minWidth: "140px" }}
          >
            <div className="mb-2">
              <div className="small text-muted">✨ Highlight</div>
              <div className="fs-4 fw-bold text-primary">{item.value}</div>
              <div className="text-primary">{item.label}</div>
            </div>
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => handleEditStat(index)}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => handleDeleteStat(index)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-muted fst-italic">No stats added yet.</p>
    )}

    {/* Add / Edit Stat Form */}
    <div className="border rounded p-3 bg-light">
      <h6 className="mb-3">
        {editingStatIndex !== null ? "Edit Stat" : "Add New Stat"}
      </h6>
      <div className="row g-2">
        <div className="col-md-4">
          <input
            type="text"
            placeholder="Value (e.g., 104+)"
            value={newStat.value}
            onChange={(e) => setNewStat({ ...newStat, value: e.target.value })}
            className="form-control"
          />
        </div>
        <div className="col-md-6">
          <input
            type="text"
            placeholder="Label (e.g., Beds)"
            value={newStat.label}
            onChange={(e) => setNewStat({ ...newStat, label: e.target.value })}
            className="form-control"
          />
        </div>
        <div className="col-md-2 d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={handleSaveStat}
          >
            {editingStatIndex !== null ? "Update" : "Add"}
          </button>
          {editingStatIndex !== null && (
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => {
                setNewStat({ value: "", label: "" });
                setEditingStatIndex(null);
              }}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
</div>


<div className="card mb-3">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Certifications</h5>
    <span className="badge bg-success">Items: {certifications.length}</span>
  </div>

  <div className="card-body">
    {certifications.length > 0 ? (
      <div className="row">
        {certifications.map((cert, index) => (
          <div key={index} className="col-md-6 mb-3">
            <div className="d-flex align-items-center border rounded p-2 bg-white">
              <img
                src={cert.image}
                alt="cert"
                className="me-3 img-fluid rounded"
                style={{ maxWidth: "70px" }}
              />
              <div className="flex-grow-1">
                <p className="mb-1 small">{cert.text}</p>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleEditCert(index)}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDeleteCert(index)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-muted fst-italic">No certifications added yet.</p>
    )}

    {/* Add / Edit Certification Form */}
    <div className="border rounded p-3 bg-light mt-3">
      <h6 className="mb-3">
        {editingCertIndex !== null ? "Edit Certification" : "Add Certification"}
      </h6>
      <div className="mb-2">
        <input
          type="text"
          placeholder="Image URL"
          value={newCert.image}
          onChange={(e) => setNewCert({ ...newCert, image: e.target.value })}
          className="form-control mb-2"
        />

        <textarea
          placeholder="Description"
          value={newCert.text}
          onChange={(e) => setNewCert({ ...newCert, text: e.target.value })}
          className="form-control mb-2"
          rows={2}
        />
      </div>
      <div className="d-flex gap-2">
        <button
          type="button"
          onClick={handleSaveCert}
          className="btn btn-success"
        >
          {editingCertIndex !== null ? "Update" : "Add Certification"}
        </button>
        {editingCertIndex !== null && (
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              setNewCert({ image: "", text: "" });
              setEditingCertIndex(null);
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  </div>
</div>


<div className="card mb-3">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Patient Stories</h5>
    <span className="badge bg-info text-dark">Stories: {stories.length}</span>
  </div>

  <div className="card-body">
    {/* Stories List */}
    {stories.length > 0 ? (
      <div className="list-group mb-3">
        {stories.map((story, index) => (
          <div
            key={index}
            className={`list-group-item list-group-item-action border-0 mb-2 rounded ${
               "bg-light"
            }`}
          >
            <div className="d-flex">
              {/* Thumbnail */}
               <img
          src={story.image}
          alt="story thumbnail"
          className="me-3 rounded"
          style={{
            width: "70px",
            height: "70px",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />

              {/* Text */}
              <div className="flex-grow-1">
                <a
                  href={story.link}
                  target="_blank"
                  rel="noreferrer"
                  className={`fw-semibold d-block mb-1 text-dark
                  }`}
                >
                  {story.title}
                </a>
                <p
                  className="mb-1 small"
                  style={{
                    color:  "#365065",
                  }}
                >
                  {story.description}
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <span
                    className="small"
                    style={{
                      color:   "#6b7b8f",
                    }}
                  >
                    {story.date}
                  </span>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className={`btn btn-sm ${
                           "btn-outline-primary"
                      }`}
                      onClick={() => handleEditStory(index)}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        "btn-outline-danger"
                      }`}
                      onClick={() => handleDeleteStory(index)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-muted fst-italic">No stories added yet.</p>
    )}

    {/* Add / Edit Story Form */}
    <div className="border rounded p-3 bg-light">
      <h6 className="mb-3">
        {editingStoryIndex !== null ? "Edit Story" : "Add New Story"}
      </h6>
      <div className="row g-2">
        <div className="col-md-6">
    <input
      type="text"
      className="form-control mb-2"
      placeholder="Image URL"
      value={newStory.image}
      onChange={(e) =>
        setNewStory({ ...newStory, image: e.target.value })
      }
    />
  </div>


        <div className="col-md-6">
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Story Link (URL)"
            value={newStory.link}
            onChange={(e) =>
              setNewStory({ ...newStory, link: e.target.value })
            }
          />
        </div>
        <div className="col-md-6">
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Title"
            value={newStory.title}
            onChange={(e) =>
              setNewStory({ ...newStory, title: e.target.value })
            }
          />
        </div>
        <div className="col-md-8">
          <textarea
            className="form-control mb-2"
            placeholder="Description / Treated by..."
            rows={2}
            value={newStory.description}
            onChange={(e) =>
              setNewStory({ ...newStory, description: e.target.value })
            }
          />
        </div>
        <div className="col-md-4">
          <input
            type="date"
            className="form-control mb-2"
            value={newStory.date}
            onChange={(e) =>
              setNewStory({ ...newStory, date: e.target.value })
            }
          />
        </div>
      </div>
      <div className="d-flex gap-2">
        <button
          type="button"
          onClick={handleSaveStory}
          className="btn btn-info text-white"
        >
          {editingStoryIndex !== null ? "Update Story" : "Add Story"}
        </button>
        {editingStoryIndex !== null && (
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              setNewStory({ link: "", title: "", description: "", date: "" });
              setEditingStoryIndex(null);
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  </div>
</div>

<div className="card mb-3">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Education</h5>
    <span className="badge bg-secondary">Items: {educationList.length}</span>
  </div>

  <div className="card-body">
    {/* Education List */}
    {educationList.length > 0 ? (
      <ul className="list-group mb-3">
        {educationList.map((edu, index) => (
          <li
            key={index}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <span>{edu}</span>

            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => handleEditEducation(index)}
              >
                Edit
              </button>

              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => handleDeleteEducation(index)}
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted fst-italic">No education added yet.</p>
    )}

    {/* Add / Edit Education */}
    <div className="border rounded p-3 bg-light">
      <h6 className="mb-3">
        {editingEducationIndex !== null ? "Edit Education" : "Add Education"}
      </h6>

      <input
        type="text"
        className="form-control mb-2"
        placeholder="Enter education (e.g., B.Sc Nursing - 2020)"
        value={newEducation}
        onChange={(e) => setNewEducation(e.target.value)}
      />

      <div className="d-flex gap-2">
        <button
          className="btn btn-secondary"
          onClick={handleSaveEducation}
          type="button"
        >
          {editingEducationIndex !== null ? "Update" : "Add"}
        </button>

        {editingEducationIndex !== null && (
          <button
            className="btn btn-outline-primary"
            onClick={() => {
              setNewEducation("");
              setEditingEducationIndex(null);
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  </div>
</div>

</>}



                      </div>
                    </div>

                    <div className="col-md-12 text-end">
                      {SubmitLoading ? (
                        <button
                          className="btn btn-gray-800 d-inline-flex align-items-center justify-content-center mb-4 ms-auto"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Update Profile
                        </button>
                      ) : (
                        <button
                          disabled
                          className="btn btn-gray-800 d-inline-flex align-items-center justify-content-center mb-4"
                          type="button"
                        >
                          <span className="ms-1">Loading...</span>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                      )}
                    </div>
                  </div>
                }
 

              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserViewEdit;
